import ErrorIcon from '@mui/icons-material/Error';
import { styled } from 'styled-components';

// TODO: Need to standardize where all these belong
export const StyledErrorIcon = styled(ErrorIcon)<{
  $errorIconColor?: string;
  $compact?: boolean;
}>`
  margin-left: auto;
  margin-right: auto;
  height: ${(props) =>
    props.$compact ? '1rem' : '1.25rem'}; /* Smaller icon for compact mode */
  width: ${(props) => (props.$compact ? '1rem' : '1.25rem')};
  color: ${(props) => props.$errorIconColor || '#ef4444'};

  .dark & {
    color: ${(props) => props.$errorIconColor || '#f87171'};
  }
`;
